<template>
  <div style="position: relative; display: inline-block;">
    <div class="reportrange-text" @click="togglePicker">
      <slot name="input">
        <span class="margin-right-20">{{startText}} - {{endText}}</span>
        <a href="#" class="btn btn-sm m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill"
           :class="`btn-ls`">
          <i class="la la-angle-down"></i>
        </a>
      </slot>
    </div>
    <transition name="slide-fade" mode="out-in">
      <div class="daterangepicker dropdown-menu ltr" :class="pickerStyles()" v-if="open"
           v-on-clickaway="clickAway">

        <div class="calendar left">
          <div class="daterangepicker_input m--hidden-mobile">
            <input class="input-mini form-control" type="text" name="daterangepicker_start"
                   :value="startText"
                   @blur="dateStartInput($event.target.value)"
                   @keydown.enter="dateStartInput($event.target.value, true)"/>
            <i class="fa fa-calendar glyphicon glyphicon-calendar"></i>
          </div>
          <div class="calendar-table">
            <calendar :monthDate="monthDate"
                      :locale="locale"
                      :start="start" :end="end"
                      @nextMonth="nextMonth" @prevMonth="prevMonth"
                      @dateClick="dateClick" @hoverDate="hoverDate"
            ></calendar>
          </div>

          <calendar-ranges :canSelect="in_selection" @clickCancel="open=false" @clickRange="clickRange"
                           @clickApply="clickedApply" :ranges="ranges" class="m--hidden-desktop m--hidden-tablet">
          </calendar-ranges>
        </div>

        <div class="calendar right m--hidden-mobile">
          <div class="daterangepicker_input">
            <input class="input-mini form-control" type="text" name="daterangepicker_end"
                   @blur="dateEndInput($event.target.value)"
                   @keydown.enter="dateEndInput($event.target.value, true)"
                   :value="endText"/>
            <i class="fa fa-calendar glyphicon glyphicon-calendar"></i>
          </div>
          <div class="calendar-table">
            <calendar :monthDate="nextMonthDate"
                      :locale="locale"
                      :start="start" :end="end"
                      @nextMonth="nextMonth" @prevMonth="prevMonth"
                      @dateClick="dateClick" @hoverDate="hoverDate"
            ></calendar>
          </div>
        </div>

        <calendar-ranges :canSelect="in_selection" @clickCancel="open=false" @clickRange="clickRange"
                         @clickApply="clickedApply" :ranges="ranges" class="m--hidden-mobile">
        </calendar-ranges>
      </div>
    </transition>
  </div>
</template>

<script>
  import moment from 'moment'
  import Calendar from './Calendar'
  import CalendarRanges from './CalendarRanges'
  import {nextMonth, prevMonth} from './util'
  import {mixin as clickaway} from 'vue-clickaway'
  import {mapState} from 'vuex'

  moment.locale('pl');

  export default {
    components: {Calendar, CalendarRanges},
    mixins: [clickaway],
    props: {
      localeData: {
        type: Object,
        default() {
          return {}
        },
      },
      startDate: {
        default() {
          return new Date()
        }
      },
      endDate: {
        default() {
          return new Date()
        }
      },
      ranges: {
        type: Object,
        default() {
          return {
            'Dzisiaj': [moment(), moment()],
            'Wczoraj': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Ten miesiąc': [moment().startOf('month'), moment().endOf('month')],
            'Ten rok': [moment().startOf('year'), moment().endOf('year')],
            'Poprzedni tydzień': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
            'Poprzedni miesiąc': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
          }
        }
      },
      opens: {
        type: String,
        default: 'center'
      }
    },
    data() {
      let default_locale = {
        direction: 'ltr',
        format: moment.localeData().longDateFormat('L'),
        separator: ' - ',
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: moment.weekdaysMin(),
        monthNames: moment.monthsShort(),
        firstDay: moment.localeData().firstDayOfWeek()
      }

      // let data = { locale: _locale }
      let data = {locale: {...default_locale, ...this.localeData}}

      data.monthDate = new Date(this.startDate)
      data.start = new Date(this.startDate)
      data.end = new Date(this.endDate)
      data.in_selection = false
      data.open = false

      // update day names order to firstDay
      if (data.locale.firstDay !== 0) {
        let iterator = data.locale.firstDay
        while (iterator > 0) {
          data.locale.daysOfWeek.push(data.locale.daysOfWeek.shift())
          iterator--
        }
      }
      return data
    },
    methods: {
      nextMonth() {
        this.monthDate = nextMonth(this.monthDate)
      },
      prevMonth() {
        this.monthDate = prevMonth(this.monthDate)
      },
      dateClick(value) {
        if (this.in_selection) {
          this.in_selection = false
          this.end = new Date(value)
          if (this.end < this.start) {
            this.in_selection = true
            this.start = new Date(value)
          }
        } else {
          this.in_selection = true
          this.start = new Date(value)
          this.end = new Date(value)
        }
      },
      hoverDate(value) {
        let dt = new Date(value)
        if (this.in_selection && dt > this.start)
          this.end = dt
      },
      togglePicker() {
        this.open = !this.open
      },
      pickerStyles() {
        let styles = {
          'show-calendar': this.open,
          opensright: this.opens === 'right',
          opensleft: this.opens === 'left',
          openscenter: this.opens === 'center'
        };

        styles[`daterangepicker-ls`] = true;
        return styles;
      },
      clickedApply() {
        this.open = false
        this.$emit('update', {startDate: this.start, endDate: this.end})
      },
      clickAway() {
        if (this.open) {
          this.open = false
        }
      },
      clickRange(value) {
        this.start = new Date(value[0])
        this.end = new Date(value[1])
        this.monthDate = new Date(value[0])
        this.clickedApply()
      },
      dateStartInput(inputValue, apply = false) {
        let date = moment(inputValue, "DD.MM.YYYY");

        if (date.isValid() && date.isSameOrBefore(moment(this.end))) {
          this.start = date.toDate();
          this.monthDate = date.toDate();
        } else {
          this.$notify.warning('Błędne ustawienie dat.')
        }

        if (apply) {
          this.clickedApply();
        }
      },
      dateEndInput(inputValue, apply = false) {
        let date = moment(inputValue, "DD.MM.YYYY");

        if (date.isValid() && date.isSameOrAfter(moment(this.start))) {
          this.end = date.toDate();
        } else {
          this.$notify.warning('Błędne ustawienie dat.')
        }

        if (apply) {
          this.clickedApply();
        }
      }
    },
    computed: {
      nextMonthDate() {
        return nextMonth(this.monthDate)
      },
      startText() {
        return moment(this.start).format('L')
      },
      endText() {
        return moment(this.end).format('L')
      },
      ...mapState({})
    },
    watch: {
      startDate(value) {
        this.start = new Date(value)
      },
      endDate(value) {
        this.end = new Date(value)
      }
    }
  }

</script>

<style>
  .margin-right-20 {
    margin-right: 20px;
  }

  .reportrange-text {
    cursor: pointer;
    padding: 5px 10px;
    width: 100%;
  }

  .daterangepicker.show-calendar {
    display: inline-flex;
  }

  @media (min-width: 768px) {
    .daterangepicker .ranges {
      width: 160px;
    }

    .ranges {
      width: 130px;
    }

    .range_inputs {
      margin-bottom: 10px;
    }
  }

  @media (max-width: 768px) {
    .range_inputs {
      padding-left: 15px;
    }
  }

  .show-calendar {
    display: block;
    width: auto;
  }

  div.daterangepicker.opensleft {
    top: 45px;
    right: 10px;
    left: auto;
  }

  div.daterangepicker.openscenter {
    top: 45px;
    right: auto;
    left: 50%;
    transform: translate(-50%, 0);
  }

  div.daterangepicker.opensright {
    top: 45px;
    left: 10px;
    right: auto;
  }

  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-fade-enter-active {
    transition: all .2s ease;
  }

  .slide-fade-leave-active {
    transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for <2.1.8 */
  {
    transform: translateX(10px);
    opacity: 0;
  }

  .daterangepicker-ls tbody td.in-range, .daterangepicker-ls tbody td.active, .daterangepicker-ls tbody td.today {
    background-color: var(--accent-color) !important;
    color: var(--btn-color) !important;
  }

  .daterangepicker-ls tbody td.off.in-range {
    color: #c0c0c0 !important;
  }
</style>
